import { useEffect, useState } from "react";
import papi, { formatErr } from "@/lib/partnerApi";
import { SectionHead } from "./VdaShared";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { Loader2, Plus, Tags } from "lucide-react";

export default function VdaCategories() {
  const [cats, setCats] = useState(null);
  const [name, setName] = useState("");
  const [adding, setAdding] = useState(false);

  const load = () => papi.get("/vda/categories").then((r) => setCats(r.data)).catch(() => setCats([]));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    setAdding(true);
    try { await papi.post("/vda/categories", { name: name.trim(), subcategories: [] }); setName(""); toast.success("Category added"); load(); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
    finally { setAdding(false); }
  };

  const toggle = async (c) => {
    try { await papi.put(`/vda/categories/${c.id}`, { active: !c.active });
      setCats((cs) => cs.map((x) => x.id === c.id ? { ...x, active: !x.active } : x)); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };

  return (
    <div className="max-w-3xl">
      <SectionHead title="Categories" desc="Manage the vendor categories available for discovery." />

      <div className="mb-5 flex gap-3 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
        <Input data-testid="cat-name" className="rounded-xl" placeholder="New category name…" value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} />
        <Button data-testid="cat-add" onClick={add} disabled={adding} className="rounded-xl bg-teal-500 hover:bg-teal-600">{adding ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Plus className="mr-1.5 h-4 w-4" /> Add</>}</Button>
      </div>

      {cats === null ? <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-teal-500" /></div> : (
        <div className="divide-y divide-slate-100 rounded-2xl border border-slate-200 bg-white shadow-sm" data-testid="cat-list">
          {cats.map((c) => (
            <div key={c.id} className="flex items-center justify-between px-5 py-3.5">
              <span className="flex items-center gap-2.5 font-medium text-slate-800"><Tags className="h-4 w-4 text-teal-500" />{c.name}</span>
              <div className="flex items-center gap-2">
                <span className={`text-xs font-medium ${c.active ? "text-emerald-600" : "text-slate-400"}`}>{c.active ? "Active" : "Inactive"}</span>
                <Switch data-testid={`cat-toggle-${c.id}`} checked={c.active} onCheckedChange={() => toggle(c)} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
